<template>
    <v-dialog v-model="dialogOpen" persistent width="400">
        <div>
            <div class="text-right">
                <v-btn
                    class="mb-3"
                    icon="mdi-close"
                    flat
                    size="x-small"
                    @click="$emit('close')"
                />
            </div>

            <div class="d-flex justify-center">
                <v-img :src="data[0]?.image" max-width="400" />
            </div>
        </div>
    </v-dialog>
</template>

<script>
export default {
    props: {
        dialog: Boolean,
        data: Object,
    },

    data() {
        return {
            dialogOpen: false,
            loading: false,
        };
    },

    watch: {
        dialog(val) {
            this.dialogOpen = val;
        },
    },
};
</script>
